import { Component, inject } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ToFontSizePipe } from '../../../pipes/to-font-size/to-font-size.pipe';
import { Dialog } from '../dialog';
import { IImage } from '@web/dtos';
import { ImageStore } from '../../../services/api/image/image-store.service';

@Component({
  selector: 'aw-image-preview-dialog',
  templateUrl: './image-preview.component.html',
  standalone: true,
  imports: [DialogComponent, ReactiveFormsModule, ToFontSizePipe],
})
export class ImagePreviewDialogComponent extends Dialog<{
  image: IImage;
  fontSize: number;
  iconBackgroundColor: string;
  icon: string;
}> {
  protected imageStore: ImageStore = inject(ImageStore);
  protected imageId: string = this.data.image.id!;
}
